import { type ReactElement } from 'react'
import { Size } from '@front/model'
import { Group, type GroupProps } from '@mantine/core'

type Props = GroupProps
export const PageFunctionBar = (props: Props): ReactElement => {
  return <Group align='center' justify='space-between' pt={Size.space['4xl']} px={Size.space['5xl']} {...props} />
}
